// extracted by mini-css-extract-plugin
export default {"root":"tweet-container_root__M8rI3","article":"tweet-container_article__atkIY"};